import { Component, computed, input } from '@angular/core';
import { RichTextComponent } from '@app/shared/components/rich-text/rich-text/rich-text.component';
import { SharedModule } from '@app/shared/shared.module';
import { PortalNotificationTranslationLike } from '@business/notification/models/portal-notification-helpers';

@Component({
  selector: 'portal-notification-item',
  imports: [RichTextComponent, SharedModule],
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent {
  showImage = input<boolean>(true);
  showTitle = input<boolean>(true);
  translation = input.required<PortalNotificationTranslationLike>();
  isNotificationTitle = computed(() => this.translation().orderIndex === 0);
}
